import React from 'react';
import RightMenuIcon from '@mui/icons-material/KeyboardArrowLeft';
import { IconButton, Tooltip } from '@mui/material';

import { useAppMonitor } from '../../../monitor';
import { getRightSidebarInfo } from '../../../store/selectors/rightToolbarSelectors';
import { leftSidebarSet, rightToolBarShowSet } from '../../../store/slices/panelDataSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarBase } from './ToolbarBase';

interface Props {
  open: boolean;

  onMobile: boolean;
  otherSidebarOpen: boolean;
}

export function LeftSidebarControlToolbar({ open, onMobile, otherSidebarOpen }: Props) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();
  const rightSidebar = useAppSelector(getRightSidebarInfo);

  return (
    <ToolbarBase orientation="horizontal" sx={{ marginLeft: '-8px!important', marginTop: '8px!important' }}>
      <Tooltip disableInteractive title="Toggle Left Sidebar">
        <span>
          <IconButton
            size="small"
            // only one sidebar can be open at a time on mobile; prevent clobbering the right sidebar if its more important
            disabled={onMobile && otherSidebarOpen && !rightSidebar.canBeClosed}
            onClick={() => {
              monitor.recordInteraction('Toggle Left Sidebar button clicked', {
                actionType: open ? 'close' : 'open',
              });
              dispatch(leftSidebarSet(open ? 'closed' : 'open'));

              // safe because this button is disabled when `!rightSidebar.canBeClosed`
              if (onMobile) dispatch(rightToolBarShowSet(false));
            }}
            id="toggle-left-sidebar-button"
            sx={[
              { border: 0, borderRadius: '5px' },
              open
                ? null
                : {
                    transform: 'rotate(180deg)',
                  },
            ]}
          >
            <RightMenuIcon />
          </IconButton>
        </span>
      </Tooltip>
    </ToolbarBase>
  );
}
